module.exports = __webpack_public_path__ + "static/dark-theme-b6188156fe2d8c60a748bd9641d25914.png";